import { buildPublicMenuUrl } from '@gl/shared';
import { EyeOff } from 'lucide-react';
import { Spinner } from '@/components/FullScreenLoader';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { api, PUBLIC_MENU_BASE_URL } from '@/lib/api';
import { useCurrentLocal, useHasRole } from '@/lib/local-context';
import { ConnectDomainCard } from './dominio/ConnectDomainCard';
import { QrCard } from './dominio/QrCard';
import { Alert, AlertDescription, AlertTitle } from './dominio/ui/alert';
import { useDomains } from './dominio/useDomains';
import { useLocalMutation } from './useUpdateLocal';

export function DominioPage() {
  const local = useCurrentLocal();
  const isOwner = useHasRole('OWNER');
  const domains = useDomains(local.id, isOwner);
  const publish = useLocalMutation(() => api.locals.publish(local.id, { published: true }), 'Tu menú ya está publicado');

  const defaultUrl = domains.data?.defaultUrl ?? buildPublicMenuUrl(local.slug, { publicMenuBaseUrl: PUBLIC_MENU_BASE_URL });
  const active = domains.data?.domains.find((d) => d.status === 'ACTIVE');

  return (
    <div className="grid gap-6">
      {!local.isPublished && (
        <Alert variant="warning">
          <EyeOff />
          <AlertTitle>Tu menú todavía no está publicado</AlertTitle>
          <AlertDescription>
            <p>Hasta que lo publiques, quien escanee el QR va a ver un aviso de &quot;menú no disponible&quot;.</p>
            {isOwner ? (
              <div className="mt-2">
                <Button size="sm" disabled={publish.isPending} onClick={() => publish.mutate(undefined)}>
                  {publish.isPending && <Spinner />} Publicar menú
                </Button>
              </div>
            ) : (
              <p>Pedile al dueño del local que lo publique.</p>
            )}
          </AlertDescription>
        </Alert>
      )}

      <QrCard local={local} defaultUrl={defaultUrl} customUrl={active?.url ?? null} />

      {isOwner ? (
        <ConnectDomainCard
          localId={local.id}
          isDemo={local.isDemo}
          data={domains.data}
          isPending={domains.isPending}
          error={domains.error}
        />
      ) : (
        <Card>
          <CardContent className="text-sm text-muted-foreground">
            Solo el dueño del local puede conectar un dominio propio.
          </CardContent>
        </Card>
      )}
    </div>
  );
}
